<div class="main">
    <div class="section">
      <div class="header">
         {{'VIEW_VEHICLE.title' | translate}}
        <i class="material-icons" (click)="closeDialog();">clear</i>
      </div>
      <div class="container">
        <div class="content">
            <div class="vehicle-info">
                <div class="info">
                    <p>{{'VIEW_VEHICLE.vehicle_number' | translate}}</p>
                    <h3>{{vehicleData.vehicle_number}}</h3>
                </div>
            </div>            
            <div class="vehicle-info">
                <div class="info">
                    <p>{{'VIEW_VEHICLE.truck_type' | translate}}</p>
                    <h3>{{vehicleData.truck_type}}</h3>
                </div>
            </div>           
            <div class="vehicle-info">
                <div class="info">
                    <p>{{'VIEW_VEHICLE.chassis_number' | translate}}</p>
                    <h3>{{vehicleData.chassis_number}}</h3>
                </div>
            </div>             
            <div class="vehicle-info">
                <div class="info">
                    <p>{{'VIEW_VEHICLE.engine_number' | translate}}</p>
                    <h3>{{vehicleData.engine_number}}</h3>
                </div>
            </div>
            <div class="vehicle-info">
                <div class="info">
                    <p>{{'VIEW_VEHICLE.registration_year' | translate}}</p>
                    <h3>{{vehicleData.registration_year}}</h3>
                </div>
            </div>     
            <div class="vehicle-info" *ngIf="vehicleData.transporter">
                <div class="info">
                    <p>Transporter</p>
                    <h3>{{vehicleData.transporter}}</h3>
                </div>
            </div>     
            <div class="vehicle-info" [hidden]="!vehicleData.mileage">
                <div class="info">
                    <p>{{'VIEW_VEHICLE.mileage' | translate}}</p>
                    <h3>{{vehicleData.mileage}} {{vehicleData.mileage_unit}}</h3>
                </div>
            </div> 
            <div class="vehicle-info" [hidden]="!vehicleData.registration_id">
                <div class="info">
                    <p>{{'VIEW_VEHICLE.registration_id' | translate}}</p>
                    <h3>{{vehicleData.registration_id}}</h3>
                </div>
            </div>  
            <div class="vehicle-info" [hidden]="!vehicleData.driver_name">
                <div class="info">
                    <p>{{'VIEW_VEHICLE.driver_name' | translate}}</p>
                    <h3>{{vehicleData.driver_name}}</h3>
                </div>
            </div>  
            <div class="vehicle-info" [hidden]="!vehicleData.mobile_number">
                <div class="info">
                    <p>{{'VIEW_VEHICLE.mobile_number' | translate}}</p>
                    <h3>{{vehicleData.mobile_number}}</h3>
                </div>
            </div>
            <div class="vehicle-info" [hidden]="!vehicleData.gps_provider">
                <div class="info">
                    <p>{{'VIEW_VEHICLE.gps_provider' | translate}}</p>
                    <h3>{{vehicleData.gps_provider}}</h3>
                </div>
            </div>                         
        </div>
      </div>
    </div>
  </div>